/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type queries_FavoritesPage_QueryVariables = {};
export type queries_FavoritesPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
    }) | null;
};
export type queries_FavoritesPage_Query = {
    readonly response: queries_FavoritesPage_QueryResponse;
    readonly variables: queries_FavoritesPage_QueryVariables;
};



/*
query queries_FavoritesPage_Query {
  viewer {
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "viewer",
            "storageKey": null,
            "args": null,
            "concreteType": "Viewer",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "id",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "queries_FavoritesPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": (v0 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "queries_FavoritesPage_Query",
            "argumentDefinitions": [],
            "selections": (v0 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "queries_FavoritesPage_Query",
            "id": null,
            "text": "query queries_FavoritesPage_Query {\n  viewer {\n    id\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8bf620a720ac5c13b2824ce79172cde1';
export default node;
